module.exports = __webpack_public_path__ + "cf41412cf17f21128fb7c5ebfa1b29ca.png";